<template>
  <div class="locale-changer mr-2">
    <Dropdown 
      v-model="selectedLang" 
      :options="supportedLocales" 
      placeholder="" 
      :class="customclass"
      @update:modelValue="changeLocale">
      <template #value="slotProps">
        <span :class="'locale-changer-flag fi fi-'+slotProps.value.replace(/.*-/g, '').toLowerCase()"></span>
        {{lang[slotProps.value.replace(/-.*/g, '').toLowerCase()]}}
      </template>
      <template #option="slotProps">
        <span :class="'locale-changer-flag fi fi-'+slotProps.option.replace(/.*-/g, '').toLowerCase()"></span>
        {{lang[slotProps.option.replace(/-.*/g, '').toLowerCase()]}}
      </template>
    </Dropdown>
  </div>
</template>

<script>
import { supportedLocales, loadMessages } from '../../i18n'
import { mapActions, mapState } from "pinia";
import { useLoginStore } from "../../stores/login.js";

export default {
    props: {
      customclass: String
    },
    data() {
        return {
          supportedLocales: supportedLocales,
          selectedLang: this.$i18n.locale,
          lang: {
            "en": "English",
            "it": "Italiano",
          }
            // lang: {
            //   en: {
            //     flag: 'gb',
            //     name: 'English'
            //   },
            //   "en-GB": {
            //     flag: 'gb',
            //     name: 'English - GB'
            //   },
            //   it: {
            //     flag: 'it',
            //     name: 'it'
            //   },
            //   "it-IT": {
            //     flag: 'it-IT',
            //     name: 'Italiano - IT'
            //   },
            //   ru: {
            //     flag: 'ru',
            //     name: 'русский'
            //   },
            //   es: {
            //     flag: 'es',
            //     name: 'Español'
            //   },
            //   du: {
            //     flag: 'nl',
            //     name: 'Nederlands'
            //   },
            //   fr: {
            //     flag: 'fr',
            //     name: 'Français'
            //   },
            //   de: {
            //     flag: 'de',
            //     name: 'Deutsche'
            //   },
            //   'en-US': {
            //     flag: 'us',
            //     name: 'United States'
            //   },
            //   ja: {
            //     flag: 'jp',
            //     name: 'やまと'
            //   },
            // }
        };
    },
    watch: {
      // '$i18n.locale': 'changeLocale'
    },
    computed: {
    ...mapState(useLoginStore, ["getTenant"]),
    },
    methods: {
      changeLocale: async function() {
        // this.$store.commit('preferences/locale', this.$i18n.locale);
        // console.log("LOCALE "+this.$i18n.locale+ " - selectedLang "+this.selectedLang);
        if(this.selectedLang === this.$i18n.locale) {
          return;
        }
        if (!this.$i18n.availableLocales.includes(this.selectedLang)) {
          console.log("async loadMessages "+this.selectedLang);
          const messages = await loadMessages(this.selectedLang, this.getTenant);
          this.$i18n.setLocaleMessage(this.selectedLang, messages);
        }
        this.$i18n.locale = this.selectedLang;
        this.$window.localStorage.setItem("smeg-dashboard-locale", this.$i18n.locale);
      },
    },
    mounted() {
      // console.log(this.$i18n);
    }
}
</script>

<style>
.rightbar-local-changer{
  width:100%;
  background-color: rgb(252,251,251);
}
.p-dropdown-panel{
  background-color: rgb(252,251,251);
}
</style>
